import { useTranslation } from 'react-i18next';
import { images } from '../../images/images';
import CustomButton from '../../components/CustomButton';
import { isTrialSolution } from '../../common/selfServiceSolutions';

interface Props {
    // The raw (already lowercased + length-capped) solution the user
    // arrived with, or null if no `solution` URL param was present /
    // nothing was stashed from a prior /signup attempt. We branch on
    // "known vs unknown" only for copy — both cases route the user to
    // the same kolula ROOM signup.
    requested: string | null;
}

const WEBSITE_URL = 'https://kolula.com';

const UnsupportedSolutionScreen = ({ requested }: Props) => {
    const { t } = useTranslation();

    const isKnown = isTrialSolution(requested);
    const solutionLabel = requested ? requested.toUpperCase() : '';

    const handleTryRoom = () => {
        // Re-enter the gated signup flow with the supported solution.
        // Using a full navigation (not React Router) so App.tsx's signup
        // effect re-runs from scratch and Auth0 sees a fresh redirect.
        window.location.assign('/signup?solution=room');
    };

    return (
        <div className={'min-h-screen bg-[rgb(var(--color-default-background))] flex items-center justify-center px-4'}>
            <div className={'w-full max-w-md'}>
                <div className={'flex flex-col items-center mb-8'}>
                    <img src={images.kolulaLogo} alt={'kolula'} className={'h-10 mb-6'} />
                    <h1 className={'text-2xl font-semibold text-foreground text-center'}>
                        {isKnown
                            ? t('unsupported_solution.title_known', { solution: solutionLabel })
                            : t('unsupported_solution.title_unknown')}
                    </h1>
                    <p className={'text-sm text-foreground/80 mt-3 text-center'}>
                        {isKnown
                            ? t('unsupported_solution.body_known', { solution: solutionLabel })
                            : t('unsupported_solution.body_unknown')}
                    </p>
                </div>

                <div className={'flex flex-col gap-3'}>
                    <CustomButton
                        title={t('unsupported_solution.primary_cta')}
                        onClick={handleTryRoom}
                        fullWidth
                    />
                    <a
                        href={WEBSITE_URL}
                        className={'text-sm text-foreground/70 hover:text-foreground text-center underline-offset-2 hover:underline'}
                    >
                        {t('unsupported_solution.back_to_website')}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default UnsupportedSolutionScreen;
